// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import produce from 'immer';
import { GET_HANH_TRINH_DON_HANG_DONE } from './constant';

export type ThongTinDonHangState = {
  hanhTrinhDonHang: any;
};

const initState: ThongTinDonHangState = {
  hanhTrinhDonHang: []
}

export const ThongTinDonHangReducer = (
  state = initState,
  action: ActionType,
): ThongTinDonHangState => {
  return produce(
    state,
    (draftState: ThongTinDonHangState): ThongTinDonHangState => {
      switch (action.type) {
        case GET_HANH_TRINH_DON_HANG_DONE:
          draftState.hanhTrinhDonHang = action.payload;
          return draftState;
        default:
          return draftState;
      }
    },
  );
};